export const SET_WINDOW_WIDTH = 'SET_WINDOW_WIDTH'
export const SET_SHOULD_SCROLL = 'SET_SHOULD_SCROLL'
export const SET_SHOULD_SHOW_MOBILE_CATEGORY = 'SET_SHOULD_SHOW_MOBILE_CATEGORY'
